import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { useAuth } from "./AuthContext";
import { IS_PREVIEW } from "./theme";

// One source for the red +N badge (desktop + mobile): invites, owner messages, admin tasks, and
// today's NHL games still un-predicted (only for users with prediction reminders on).
export function useInboxCounts() {
    const { user, isOwner } = useAuth();
    const isAdminRole = ["admin", "owner"].includes(user?.role);
    const { data: invites } = useQuery({ queryKey: ["league-invites"], queryFn: () => api.get("/leagues/invites").then((r) => r.data.invites), enabled: !!user });
    const { data: msgs } = useQuery({ queryKey: ["messages"], queryFn: () => api.get("/messages").then((r) => r.data), enabled: !!isOwner });
    const { data: tasks } = useQuery({ queryKey: ["admin-tasks-count"], queryFn: () => api.get("/admin/tasks/count").then((r) => r.data.count), enabled: isAdminRole && !IS_PREVIEW, refetchInterval: 5 * 60 * 1000 });
    const { data: preds } = useQuery({ queryKey: ["predictions-pending"], queryFn: () => api.get("/account/predictions-pending").then((r) => r.data.count), enabled: !!user && !IS_PREVIEW, refetchInterval: 5 * 60 * 1000 });
    const inbox = (invites?.length || 0) + (msgs?.unread || 0);
    const total = user ? inbox + (tasks || 0) + (preds || 0) : 0;
    // Where tapping the badge goes: tasks first, then predictions, else the inbox.
    const to = tasks ? "/tasks" : preds ? "/nhl/schedule" : "/messages";
    return { inbox, tasks: tasks || 0, preds: preds || 0, total, to };
}
